import { Lock } from "lucide-react";
import PropTypes from "prop-types";
import Select from "@components/ui-components/select";
import StatusChip from "@components/ui-components/status-chip";
import LoadingButton from "@components/ui-components/loading-button";
import { KYC_LABEL, KYC_STATUS_OPTIONS, KYC_TONE } from "@src/utility/constants/panel/common";
import KycTimeline from "./kyc-timeline";

// The select only drafts a status; Apply is what moves it on record, and it
// stays disabled until the draft actually differs from what is stored.
const KycStatusCard = ({
    status,
    statusDraft,
    canUpdateStatus,
    isStatusDirty,
    statusNote,
    saving,
    timeline,
    onStatusDraftChange,
    onApplyStatus
}) => (
    <section className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-2">
            <h3 className="text-sm font-semibold text-gray-900">Status</h3>
            {status && <StatusChip tone={KYC_TONE[status] || "neutral"} label={KYC_LABEL[status] || status} />}
        </div>

        <div className="mt-4">
            <Select
                id="brand-kyc-status"
                size="sm"
                className="w-full"
                label="Update status"
                placeholder="Select status"
                value={statusDraft}
                options={KYC_STATUS_OPTIONS}
                disabled={!canUpdateStatus || saving}
                isClearable={false}
                onChange={onStatusDraftChange} />
            {statusNote && (
                <p className="mt-1.5 flex items-start gap-1.5 text-xs text-muted">
                    <Lock className="mt-0.5 h-3 w-3 shrink-0" />
                    {statusNote}
                </p>
            )}

            <div className="mt-3 flex items-center justify-end gap-2">
                <LoadingButton
                    size="sm"
                    text="Apply"
                    loadingText="Saving…"
                    loading={saving}
                    disabled={!canUpdateStatus || !isStatusDirty}
                    onClick={onApplyStatus}
                    testId="apply-kyc-status" />
            </div>
        </div>

        <h3 className="mt-6 text-sm font-semibold text-gray-900">Timeline</h3>
        <KycTimeline timeline={timeline} />
    </section>
);

KycStatusCard.propTypes = {
    status             : PropTypes.string,
    statusDraft        : PropTypes.string,
    canUpdateStatus    : PropTypes.bool,
    isStatusDirty      : PropTypes.bool,
    statusNote         : PropTypes.string,
    saving             : PropTypes.bool,
    timeline           : PropTypes.array.isRequired,
    onStatusDraftChange: PropTypes.func.isRequired,
    onApplyStatus      : PropTypes.func.isRequired
};

export default KycStatusCard;
